import React from "react";
import { Link } from "react-router-dom";



const CbtMembJoinLink = ({referrer,membJoinLinkTxt,inModal=false,onChangeView,noWrap=false}:any) => {
    const handleClick = (target:string) => (e:any) => {
        if (inModal && typeof onChangeView === 'function') {
            e.preventDefault();
            onChangeView(target);
            return;
        }
        // otherwise allow normal Link behavior
    }

    return(
        <>
        <div className={`membJoinLinkWrap${noWrap ? " noWrap" : ""}`}>
            <ul>
                <li>
                    {inModal ? (
                        <a href="/MembFindId" onClick={handleClick('MembFindId')}>
                            <p>{membJoinLinkTxt[0]}</p>
                        </a>
                    ) : (
                        <Link to="/MembFindId">
                            <p>{membJoinLinkTxt[0]}</p>
                        </Link>
                    )}
                </li>
                <li>
                    {inModal ? (
                        <a href="/MembFindPw" onClick={handleClick('MembFindPw')}>
                            <p>{membJoinLinkTxt[1]}</p>
                        </a>
                    ) : (
                        <Link to="/MembFindPw">
                            <p>{membJoinLinkTxt[1]}</p>
                        </Link>
                    )}
                </li>
                <li>
                    {inModal ? (
                        <a href={`/MembJoin?referrer=${encodeURIComponent(referrer||'')}`} onClick={handleClick('MembJoin')}>
                            <p>{membJoinLinkTxt[2]}</p>
                        </a>
                    ) : (
                        <Link to={`/MembJoin?referrer=${encodeURIComponent(referrer)}`}>
                            <p>{membJoinLinkTxt[2]}</p>
                        </Link>
                    )}
                </li>
            </ul>
        </div>
        </>
    )
}

export default CbtMembJoinLink;

